import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap";
import productImg from '../../wallpaper/pr_1.png';

const OrderList = ({ orderList, handleOrderModal, handleProductDetailModal }) => {
  const { t } = useTranslation();
  return (
    <Row className="g-3" style={{minHeight: '350px'}}>
      {orderList?.length > 0 &&
        orderList.map((orgProduct) => (
          <Col key={orgProduct?.orgProductId} xs={12} sm={6} md={4}>
            <Card
              style={{
                // border: "2px solid #00bfff",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                padding: "10px",
                cursor: "pointer",
                height: "100%",
              }}
            >
              <div style={{ display: "flex", position: "relative" }}>
                {/* Image */}
                <img
                  src={orgProduct?.image || productImg}
                  alt={orgProduct?.name || "product"}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    marginRight: "10px",
                  }}
                />

                {/* Content */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      marginBottom: "5px",
                    }}
                  >
                    {orgProduct?.name || t("user.orderList.productPlaceholder")}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#555",
                      lineHeight: "1.3",
                    }}
                  >
                    {t("common.description")} :{" "}
                    {(orgProduct?.description?.substring(0, 55))}
                    {orgProduct?.description?.length > 55 ? "..." : ""}
                  </div>
                  <button
                    type="button"
                    className="product-read-more-btn"
                    onClick={() => handleProductDetailModal(orgProduct)}
                  >
                    {t("user.orderList.readMore")}
                  </button>
                </div>

                {/* Cart Icon */}
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    padding: "4px",
                  }}
                >
                  <i onClick={() => handleOrderModal(orgProduct)} className="fa fa-cart-plus" style={{ fontSize: "1rem" }}></i>
                </div>
              </div>
            </Card>
          </Col>
        ))}
    </Row>
  );
};

export default OrderList;
